import { observer } from "mobx-react-lite";
import { DataImportObservable } from "@/store/data-imports/DataImportObservable";
import { MDSIcon, MDSIconColor, MDSIconKind } from "@/mds";

interface Props {
  dataImport: DataImportObservable;
}

export const DataImportStatusIndicator = observer(({ dataImport }: Props) =>
  dataImport.isRunning ? (
    <MDSIcon kind={MDSIconKind.SpinnerSolid} />
  ) : dataImport.endedWithError ? (
    <MDSIcon kind={MDSIconKind.Danger} color={MDSIconColor.Danger} />
  ) : (
    <MDSIcon kind={MDSIconKind.CheckCircleSolid} color={MDSIconColor.Positive} />
  )
);
